<div *ngIf="cs.isBrowser" [formGroup]="form" class="form-group app-select">
  <label *ngIf="field.label">
    {{ field.label }}{{ field.validation?.required ? '*' : '' }}
    <app-info-icon
      [message]="field.infoIconMessage"
      *ngIf="field.infoIconMessage"
    ></app-info-icon>
  </label>
  <ng-select
    [placeholder]="field.placeholder"
    [formControlName]="field.name"
    [disabled]="field.disabled"
    [clearable]="!!field.clearable"
    [compareWith]="compareSelectOptions"
    [ngClass]="{ 'select-no-op': !field?.options?.length, 'select-clearable': field.clearable }"
    class="type-experience"
    #select
    (change)="select?.blur()"
  >
    <ng-option
      *ngFor="let item of field?.options"
      [value]="field.bindObjectValue ? item : getNestedValue(item, field.valueKey)"
      [disabled]="item.disabled"
      class="select-option"
    >
      <span *ngIf="field.emojiIconKey" class="emoji-icon">
        {{ item[field.emojiIconKey] }}
      </span>
      <em 
        *ngIf="field?.iconClass && item[field?.iconClass]"
        [ngClass]="[item[field?.iconClass], 'extra-icon']"
      ></em>
      <span>{{ item[field.labelKey] }}</span>
    </ng-option>
  </ng-select>

  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
